'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroMultipleSelect = require('./NitroMultipleSelect');

var _NitroMultipleSelect2 = _interopRequireDefault(_NitroMultipleSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroMultipleSelect2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-multiple-select/index.js
// module id = 402
// module chunks = 4